

class RadioControlController {
    constructor() {
    }
}

export default RadioControlController;



// WEBPACK FOOTER //
// ./client/app/common/radio-control/radio-control.controller.js